import { Flex, Text } from '@mantine/core';
import type { ReactNode } from 'react';

export type EntityMetadataItem = {
  id: string;
  label: ReactNode;
  value: ReactNode;
};

export type EntityMetadataProps = {
  items: readonly EntityMetadataItem[];
};

export const EntityMetadata = ({ items }: EntityMetadataProps) => {
  return (
    <Flex align='center' w='100%' justify='space-between' wrap='wrap'>
      <Flex wrap='wrap' rowGap={16} columnGap={32} align='center'>
        {items.map(item => (
          <Flex key={item.id} gap={8} align='center'>
            <Text size='sm' c='tertiary.7'>
              {item.label}
            </Text>
            <Text component='div' size='sm' c='primary.7'>
              {item.value}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
